export const environment = {
  production: true,
  version: '0.0.1',

  // Default configuration for production
  // ALL values loaded at runtime by:
  //   - assets/configs/config.js (ConfigMap K8s) → NON-sensitive variables
  //   - assets/runtime/env-secrets.js (Secret K8s) → SENSITIVE variables
  config: {
    ENVIRONMENT: '', // 🔧 Loaded from window.__APP_CONFIG__
    KEYCLOAK_ISSUER: '', // 🔧 Loaded from window.__APP_CONFIG__
    KEYCLOAK_CLIENTID: '', // 🔧 Loaded from window.__APP_CONFIG__
    KEYCLOAK_SECRET: '', // 🔐 Loaded from window.__APP_SECRETS__
    ENDPOINT_TOKEN: '', // 🔧 Loaded from window.__APP_CONFIG__
    oauth2_scopes: '', // 🔧 Loaded from window.__APP_CONFIG__
    REDIRECT_URI: '', // 🔧 Loaded from window.__APP_CONFIG__
    KEYCLOAK_LOGOUT_REDIRECT: '', // 🔧 Loaded from window.__APP_CONFIG__
    BACKEND_URL: '', // 🔧 Loaded from window.__APP_CONFIG__
    BACKEND_SUB_PATH: '' // 🔧 Loaded from window.__APP_CONFIG__
  }
};
